(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/views/joker/joker-row.js') >= 0) return;  svs.modules.push('/components/numbergames/game/views/joker/joker-row.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.game=_svs.numbergames.game||{};
_svs.numbergames.game.templates=_svs.numbergames.game.templates||{};
svs.numbergames.game.templates.joker_row = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"grid-row\">\n  <button class=\"js-joker-ball-row joker-ball-row col-xs-8\">\n    <div id=\"jokerBallRowRegion\"></div>\n  </button>\n  "
    + container.escapeExpression((lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"button",{"name":"ui","hash":{"size":200,"transparent":true,"title":"Slumpa","class":"js-joker-huxflux-btn joker-huxflux-btn col-xs-4"},"data":data,"loc":{"start":{"line":5,"column":2},"end":{"line":10,"column":4}}}))
    + "\n</div>";
},"useData":true});
Handlebars.partials['components-numbergames-game-joker_row'] = svs.numbergames.game.templates.joker_row;
})(svs, Handlebars);

 })(window);